import { transformToPeriod } from '../Period/PeriodTransformers'
import { PayrollPeriodWeek, PayrollPeriodWeekResource } from './PayrollPeriodWeek'

export const transformToPayrollPeriodWeek = (resource: PayrollPeriodWeekResource): PayrollPeriodWeek => ({
    id: resource.id,
    isLocked: resource.isLocked,
    period: transformToPeriod(new Date(resource.start), new Date(resource.end)),
})
